import { mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import ArticlesStateMixins from '@/modules/content/components/ContentPage/mixins/ArticlesStateMixins';
import * as accountTypes from '@/modules/account/store/types';

export default {
  name: 'ArticlesActionsMixins',
  mixins: [
    ArticlesStateMixins,
  ],
  computed: {
    ...mapGetters('account', [
      accountTypes.GET_IS_MANAGED_ACCOUNT,
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_ARTICLE_BY_ID,
    ]),
  },
  methods: {
    canPublishArticles({ ids } = {}) {
      if (this.GET_IS_CAMPAIGN_READONLY) return false;
      return ids.every((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return article?.matchingHealth !== 'LOW' && !['PUBLISHED', 'FAILED'].includes(article?.state);
      });
    },
    canPauseArticles({ ids } = {}) {
      if (this.GET_IS_CAMPAIGN_READONLY) return false;
      return ids.every((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return ['PUBLISHED', 'SCHEDULED'].includes(article?.state);
      });
    },
    canScheduleArticles({ ids } = {}) {
      if (this.GET_IS_CAMPAIGN_READONLY) return false;
      return ids.every((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return article?.matchingHealth !== 'LOW' && ['DRAFT', 'PAUSED', 'PUBLISHED'].includes(article?.state);
      });
    },
    canDeleteArticles({ ids }) {
      if (this.GET_IS_CAMPAIGN_READONLY) return false;
      return ids.some((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return ['DRAFT', 'FAILED'].includes(article?.state);
      });
    },
    canChangeArticlesLanguage({ ids }) {
      if (this.GET_IS_CAMPAIGN_READONLY) return false;
      return ids.every((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return ['DRAFT', 'PAUSED'].includes(article?.state);
      });
    },
  },
};
